export default {"src":"/_next/static/media/cross_modal.bc6a3ccc.svg","height":53,"width":51,"blurWidth":0,"blurHeight":0};